__turbopack_context__.v({
  "centerSection": "ProgramPageHeader-module__4BXYja__centerSection",
  "logo": "ProgramPageHeader-module__4BXYja__logo",
  "rightSection": "ProgramPageHeader-module__4BXYja__rightSection",
  "root": "ProgramPageHeader-module__4BXYja__root",
  "title": "ProgramPageHeader-module__4BXYja__title",
});
